<template>
  <div>
    <ToolbarAuth />
    <Navigation />
    <div v-if="loadingA || loadingB || loadingC">
      <loading />
    </div>
    <div v-if="!loadingA || !loadingB || !loadingC">
      <div class="mt-15 ml-15 mr-15">
        <v-card>
          <v-card-title class="primary--text text-uppercase"> {{ $t("crud.invits") }} {{ dataFam.family_name }} </v-card-title>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left text-uppercase" width="150px">
                      {{ $t("users.first_name") }}
                    </th>
                    <th class="text-left text-uppercase" width="250px">
                      {{ $t("users.last_name") }}
                    </th>
                    <th class="text-left text-uppercase" width="75px">
                      {{ $t("crud.be_send") }}
                    </th>
                    <th class="text-left text-uppercase" width="200px">
                      {{ $t("crud.date_send") }}
                    </th>
                    <th class="text-left text-uppercase" width="75px">
                      {{ $t("crud.send") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr :key="dataex.id" v-for="dataex in dataext">
                    <td>{{ dataex.first_name }}</td>
                    <td>{{ dataex.last_name }}</td>
                    <td>
                      <v-icon class="accent--text" v-show="dataex.email_send">mdi-check </v-icon>
                      <v-icon class="primary--text" v-show="!dataex.email_send">mdi-minus-box </v-icon>
                    </td>

                    <td v-if="dataex.email_send">
                      {{ dataex.email_send_date | myDate }}
                    </td>
                    <td v-if="!dataex.email_send"></td>
                    <td>
                      <v-btn @click="sendMail(dataex.id)" small color="accent" v-show="!dataex.email_send">{{ $t("crud.send") }}</v-btn>
                      <v-btn @click="sendMail(dataex.id)" small color="info" v-show="dataex.email_send" :disabled="disableBtn">{{ $t("crud.resend") }}</v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <div class="mt-16 ml-8 mb-8">
            <h3 class="info--text">
              {{ $t("fchart.other_inform") }}
            </h3>
            <br /><br />
            <v-row>
              <p class="accent--text">App</p>
            </v-row>
            <v-row>
              <v-col cols="8"> <v-text-field full-width outlined readonly v-model="this.linkApp" id="testing-code" /></v-col>
              <v-col>
                <v-btn class="ml-8 mt-3" @click.stop.prevent="copyTestingCode">copy</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <p class="accent--text">Family code</p>
            </v-row>
            <v-row>
              <v-col cols="8"> <v-text-field full-width outlined readonly v-model="this.dataFam.token_fam" id="fam-code" /></v-col>
              <v-col>
                <v-btn class="ml-8 mt-3" @click.stop.prevent="copyFamCode">copy</v-btn>
              </v-col>
            </v-row>
            <v-btn class="ma-2" outlined href="/files/Installatie.pdf" download> Instructies </v-btn>
          </div>
          <v-card-actions>
            <v-spacer />
            <v-btn @click="closeView()" class="ma-5" color="accent">
              {{ $t("crud.close") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import Navigation from "@/components/navigation/Navigation";
import LchartmemberService from "@/services/lchart/LchartmemberService";
import LinkService from "@/services/maintain/LinkService";
import Loading from "@/components/loading";
import LchartService from "@/services/lchart/LchartService";
export default {
  name: "Invitation",
  components: { Loading, ToolbarAuth, Navigation },
  data() {
    return {
      loadingA: false,
      loadingB: false,
      loadingC: false,
      disableBtn: false,
      dataext: [],
      sending: false,
      dataFam: {
        token_fam: "test",
      },
      linkData: {
        chart_full: "test",
      },
    };
  },
  methods: {
    copyTestingCode() {
      let testingCodeToCopy = document.querySelector("#testing-code");
      testingCodeToCopy.setAttribute("type", "text");
      testingCodeToCopy.select();
      try {
        document.execCommand("copy");
        // eslint-disable-next-line no-undef
        EventBus.$emit("clipSuc", true);
      } catch (err) {
        // eslint-disable-next-line no-undef
        EventBus.$emit("clipProblem", true);
      }
    },
    copyEnCode() {
      let enCodeToCopy = document.querySelector("#en-code");
      enCodeToCopy.setAttribute("type", "text");
      enCodeToCopy.select();
      try {
        document.execCommand("copy");
        // eslint-disable-next-line no-undef
        EventBus.$emit("clipSuc", true);
      } catch (err) {
        // eslint-disable-next-line no-undef
        EventBus.$emit("clipProblem", true);
      }
    },
    copyFamCode() {
      let testingCodeToCopy = document.querySelector("#fam-code");
      testingCodeToCopy.setAttribute("type", "text");
      testingCodeToCopy.select();
      try {
        document.execCommand("copy");
        // eslint-disable-next-line no-undef
        EventBus.$emit("clipSuc", true);
      } catch (err) {
        // eslint-disable-next-line no-undef
        EventBus.$emit("clipProblem", true);
      }
    },

    getData() {
      let id = this.$route.params.famId;
      this.loadingA = true;
      LchartmemberService.getMains(id)
        .then((response) => {
          this.dataext = response.data.data;
        })
        .finally(() => (this.loadingA = false));
    },

    getDataB() {
      let id = this.$route.params.famId;
      this.loadingB = true;
      LchartService.getMain(id)
        .then((response) => {
          this.dataFam = response.data.data;
        })
        .finally(() => (this.loadingB = false));
    },

    getLinks() {
      let linkId = 1;
      this.loadingC = true;
      LinkService.getMain(linkId)
        .then((response) => {
          this.linkData = response.data.data;
        })
        .finally(() => (this.loadingC = false));
    },

    sendMail(iD) {
      this.sending = true;
      this.disableBtn = true;
      LchartmemberService.sendEmail(iD)
        .then((response) => {
          this.dataext = response.data.data;
        })
        .finally(() => {
          this.disableBtn = false;
          this.sending = false;
          this.getData();
        });
    },
    closeView() {
      this.$router.replace({
        name: "lchartIndex",
      });
    },
  },
  created() {
    this.getData();
    this.getDataB();
    this.getLinks();
  },

  computed: {
    linkApp: function () {
      return this.linkData.chart_light;
    },
    linkAppEn: function () {
      return this.linkData.chart_full_en;
    },
  },
};
</script>

<style scoped></style>
